import { useEffect, useState, useContext } from 'react';
import { useForm } from "react-hook-form";
import { Modal, Button } from 'react-bootstrap';
import * as Api from '../../api/Api';
import { useQuery } from 'react-query';
import * as KeyNames from '../../api/KeyNames';
import { ErrorConnection } from '../../Components/Error/Error';
import { Loading } from '../../Components/Loading/Loading';
import { FeedbackContext } from "../../Components/Context/FeedbackContext";
import { useGetToken } from '../../Hooks/CustomHooks';
import PermissionsGate from '../../../app/api/PermissionsGate';
import { SCOPES } from '../../../app/config/permissions-map';
import { SessionContext } from '../../Components/Context/SessionContext';

export default function EditUser({ userEdit, setUserEdit, setShowEditUser, showEditUser, setRefreshData }) {
    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);
    const [updatedUser, setUpdatedUser] = useState(null);
    const [selectedRol, setSelectedRol] = useState(userEdit.rol);
    const { session } = useContext(SessionContext);
    const { register, handleSubmit, formState: { errors }, reset, setValue } = useForm();
    const onSubmit = dataUpdatedUser => {
        dataUpdatedUser.role ? setUpdatedUser(dataUpdatedUser) : setUpdatedUser({ ...dataUpdatedUser, role: selectedRol });
    };
    const onChangeRol = (option) => {
        setValue('rol', option.target.value);
        setSelectedRol(option.target.value)
    }

    useEffect(() => {
        setValue('name', userEdit.name);
        setValue('email', userEdit.email);
        setValue('rol', userEdit.rol);
        setValue('dni', (userEdit.dni) ? userEdit.dni : '');
        setValue('userState', userEdit.userState ? "Activo" : "Bloqueado");
    })

    const rolOptions = session.roleList.map(item => ({ value: item.id, label: item.name }))
    const token = useGetToken();
    //Llamada al servicio de EDITUSER
    let { data, isLoading, isError, error } = useQuery([KeyNames.SessionRespuesta, updatedUser && updatedUser],
        async () => await Api.editUser({ updatedUser, token }),
        {
            enabled: Boolean(updatedUser)
        });

    useEffect(() => {
        if (data) {
            if (data.success) {
                setFeedbackContext({ ...feedbackContext, showMessage: true, idMessage: 101 });
                reset(null);
                setUpdatedUser(null);
                setRefreshData(true);
                setShowEditUser(false);
            } else {
                setFeedbackContext({ ...feedbackContext, showError: true, idError: data.errorId });
            }
        }

    }, [data]);

    if (isLoading) return (<Loading />)
    if (isError) return (<ErrorConnection error={error/*.response.status*/} />)

    return (
        <PermissionsGate RenderError={() => <></>} scopes={[SCOPES.GESTION_USUARIOS]} >
            <Modal show={showEditUser} onHide={() => {
                setUserEdit({})
                setShowEditUser(false)
            }} aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header>
                    <Modal.Title>Actualizar los detalles del usuario</Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    <form>
                        <div className="fv-row mb-7 ">
                            <label className="required fw-bold fs-6 mb-2">Correo Electrónico</label>
                            <input defaultValue={userEdit.email} type="email" {...register("email", { required: true })} className="form-control form-control-solid mb-3 mb-lg-0" placeholder="Correo Electrónico" />
                            <>{errors.email && <span className="text-danger">Ingresar el correo</span>}</>
                        </div>

                        <div className="fv-row mb-7 ">
                            <label className="required fw-bold fs-6 mb-2">Nombre Completo</label>
                            <input defaultValue={userEdit.name} type="text" {...register("name", { required: true })} className="form-control form-control-solid mb-3 mb-lg-0" placeholder="Nombre Completo" />
                            <>{errors.name && <span className="text-danger">Ingresar el nombre</span>}</>
                        </div>

                        <div className="fv-row mb-7 ">
                            <label className="fw-bold fs-6 mb-2">DNI</label>
                            <input defaultValue={userEdit.dni} type="text" {...register("dni", { required: false })} className="form-control form-control-solid mb-3 mb-lg-0" placeholder="DNI" />
                            <>{errors.name && <span className="text-danger">Ingresar el DNI</span>}</>
                        </div>

                        <PermissionsGate RenderError={() => <></>} scopes={[SCOPES.GESTION_USUARIOS]} >
                            <div className="fv-row mb-7">
                                <label className="required fw-bold fs-6 mb-2">Rol</label>
                                <select className="form-select form-select-solid" value={selectedRol} {...register("rol", { required: true })} onChange={(onChangeRol)}>
                                    <option value="">Selecciona</option>
                                    {
                                        session.roleList.map(role => <option key={role.id} value={role.id}> {role.name}</option>)
                                    }
                                </select>
                                <>{errors.role && <span className="text-danger">Selecciona un rol</span>}</>
                            </div>
                        </PermissionsGate>

                        <div className="fv-row mb-7">
                            <label className="required fw-bold fs-6 mb-2">Estado de Usuario</label>
                            <select defaultValue={userEdit.userState ? "Activo" : "Bloqueado"} {...register("userState")} className="form-select form-select-solid" >
                                <option value="Activo">Activo</option>
                                <option value="Bloqueado">Bloqueado</option>
                            </select>
                        </div>

                    </form>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secundary" onClick={() => setShowEditUser(false)}>Descartar</Button>
                    <Button variant="primary" onClick={handleSubmit(onSubmit)}>Actualizar</Button>
                </Modal.Footer>
            </Modal>
        </PermissionsGate>
    )
}
